import * as yup from 'yup'
import { DecisionNode, DecisionOutcome, ExperimentConfigType, ExperimentMode, experimentType, experimentTypeKeys, questionType } from '../_config/types'
export const purposeOptions = [
    {
        label: 'Viewing Experiments and Results',
        value: 'Viewing Experiments and Results',
    },
    {
        label: 'Designing Experiments',
        value: 'Designing Experiments',
    },
    {
        label: 'Measuring Impact of Experiments',
        value: 'Measuring Impact of Experiments',
    },
    {
        label: 'Measuring and Reporting Value Creation',
        value: 'Measuring and Reporting Value Creation',
    },
]

export const significanceDropdownLevels = [
    {
        label: '80%',
        value: '80',
    },
    {
        label: '85%',
        value: '85',
    },
    {
        label: '90%',
        value: '90',
    },
    {
        label: '95%',
        value: '95',
    },
    {
        label: '99%',
        value: '99',
    },
    {
        label: '99.5%',
        value: '99.5',
    },
    {
        label: '99.9%',
        value: '99.9',
    },
]

export const powerOfTest = [
    {
        label: '70',
        value: '70',
    },
    {
        label: '75',
        value: '75',
    },

    {
        label: '80',
        value: '80',
    },

    {
        label: '85',
        value: '85',
    },

    {
        label: '90',
        value: '90',
    },

    {
        label: '95',
        value: '95',
    },
    {
        label: '99',
        value: '99',
    },
]

export const MISSING_VALUE_MSG = 'This column has missing values'

export const CANCEL_EXPERIMENT_STEP = {
    DESIGN: 'design',
    MEASUREMENT: 'measurement',
    RCT: 'rct',
    DTW: 'dtw',
    CANCELLED: 'cancelled',
}

export const ADVANCE_CONFIG_OPTION = {
    SYNTHETIC_CONTROL: { label: 'Synthetic Control', value: 'synthetic_control', methodology: 'SYNTHETIC_CONTROL' },
    DID: { label: 'DID', value: 'did', methodology: 'DID' },
}

export const GRAPH_FAILED_MESG = 'The graphs for blocking factor was not generated because no blocking factors were selected.'

export const DefaultProfile = {
    name: '',
    email: '',
    zone: null,
    country: null,
    businessFunction: null,
    role: null,
    purpose: null,
    workSpaceName: '',
    clusterUrl: '',
    jdbcUrl: '',
}

export const ProfileValidationSchema = yup.object().shape({
    name: yup.string().optional(),
    email: yup.string().optional().email('Invalid Email'),
    zone: yup
        .mixed()
        .test('select-at-least-one-option', 'Zone is required', (value) => (Array.isArray(value) ? value.length > 0 : !!value))
        .required('Zone is required'),

    businessFunction: yup
        .mixed()
        .test('select-at-least-one-option', 'Business Function is required', (value) => (Array.isArray(value) ? value.length > 0 : !!value))
        .required('Business Function is required'),
    role: yup
        .mixed()
        .test('select-at-least-one-option', 'Role is required', (value) => (Array.isArray(value) ? value.length > 0 : !!value))
        .required('Role is required'),

    purpose: yup
        .mixed()
        .test('select-at-least-one-option', 'Purpose is required', (value) => (Array.isArray(value) ? value.length > 0 : !!value))
        .required('Purpose is required'),
})

export const EXPERIMENT_TYPES: Record<experimentTypeKeys, experimentType> = {
    RCT: {
        title: 'RCT',
        experiment_type_literal: 'RCT',
        baselineDates: true,
        periodOfExperimentation: true,
        maximumKPIs: 3,
        defaultKPIConfig: {
            onlyContinuous: { enabled: true, custom: true, max: 3 },
            onlyDiscrete: { enabled: true, custom: false, max: 1 },
        },
        customKPIConfig: {
            onlyContinuous: { enabled: true, default: true, max: 3 },
            onlyDiscrete: { enabled: true, default: true, max: 3 },
            onlyPercentage: { enabled: true, default: true, max: 3 },
        },
        minimumGroups: 2,
        maximumGroups: 5,
        design: true,
        measurement: true,
        minConfidence: 80,
        maxConfidence: 99.9,
    },
    OBS: {
        title: 'Observational Study',
        experiment_type_literal: 'OBS',
        baselineDates: true,
        periodOfExperimentation: true,
        maximumKPIs: 3,
        defaultKPIConfig: {
            onlyContinuous: { enabled: true, custom: true, max: 3 },
            onlyDiscrete: { enabled: true, custom: false, max: 1 },
        },
        customKPIConfig: {
            onlyContinuous: { enabled: true, default: true, max: 3 },
            onlyDiscrete: { enabled: true, default: true, max: 3 },
            onlyPercentage: { enabled: true, default: true, max: 3 },
        },
        minimumGroups: 2,
        maximumGroups: 2,
        design: true,
        measurement: true,
        minConfidence: 80,
        maxConfidence: 99.9,
    },
    PTC: {
        title: 'Post-Treatment Comparison',
        experiment_type_literal: 'PTC',
        baselineDates: false,
        periodOfExperimentation: true,
        maximumKPIs: 0,
        defaultKPIConfig: {
            onlyContinuous: { enabled: true, custom: true, max: 3 },
            onlyDiscrete: { enabled: true, custom: false, max: 1 },
        },
        customKPIConfig: {
            onlyContinuous: { enabled: true, default: true, max: 3 },
            onlyDiscrete: { enabled: true, default: true, max: 3 },
            onlyPercentage: { enabled: true, default: true, max: 3 },
        },
        minimumGroups: 2,
        maximumGroups: 0,
        design: false,
        measurement: true,
        minConfidence: 80,
        maxConfidence: 99.9,
    },
    PRE_POST: {
        title: 'Pre-Post Analysis',
        experiment_type_literal: 'PRE_POST',
        baselineDates: true,
        periodOfExperimentation: true,
        maximumKPIs: 0,
        defaultKPIConfig: {
            onlyContinuous: { enabled: true, custom: true, max: 3 },
            onlyDiscrete: { enabled: true, custom: false, max: 1 },
        },
        customKPIConfig: {
            onlyContinuous: { enabled: true, default: true, max: 3 },
            onlyDiscrete: { enabled: true, default: true, max: 3 },
            onlyPercentage: { enabled: true, default: true, max: 3 },
        },
        minimumGroups: 2,
        maximumGroups: 0,
        design: false,
        measurement: true,
        minConfidence: 80,
        maxConfidence: 99.9,
    },
    MTE: {
        title: 'MTE',
        experiment_type_literal: 'MTE',
        baselineDates: true,
        periodOfExperimentation: true,
        maximumKPIs: 1,
        defaultKPIConfig: {
            onlyContinuous: { enabled: true, custom: false, max: 1 },
            onlyDiscrete: { enabled: false, custom: false, max: 0 },
        },
        customKPIConfig: {
            onlyContinuous: { enabled: true, default: false, max: 1 },
            onlyDiscrete: { enabled: false, default: false, max: 0 },
            onlyPercentage: { enabled: false, default: false, max: 0 },
        },
        minimumGroups: 2,
        maximumGroups: 2,
        design: false,
        measurement: true,
        minConfidence: 90,
        maxConfidence: 90,
    },
    DML: {
        title: 'DML',
        experiment_type_literal: 'DML',
        baselineDates: true,
        periodOfExperimentation: true,
        maximumKPIs: 1,
        defaultKPIConfig: {
            onlyContinuous: { enabled: true, custom: false, max: 1 },
            onlyDiscrete: { enabled: false, custom: false, max: 0 },
        },
        customKPIConfig: {
            onlyContinuous: { enabled: true, default: false, max: 1 },
            onlyDiscrete: { enabled: false, default: false, max: 0 },
            onlyPercentage: { enabled: false, default: false, max: 0 },
        },
        minimumGroups: 2,
        maximumGroups: 2,
        design: false,
        measurement: true,
        minConfidence: 95,
        maxConfidence: 95,
    },
}

export const EXPERIMENT_DETECTION_QUESTIONS_FLOW: Record<keyof ExperimentConfigType, questionType> = {
    interventionOccurred: {
        question: 'Has the Intervention already occurred?',
        info: 'If all you want to do is measure the impact of an experiment you have already conducted, please select YES.',
        options: [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ],
        required: true,
    },
    interventionOnGroup: {
        question: 'Does the intervention cover the entire serviceable market?',
        info: 'Select YES if the intervention was, or will be, rolled out to the entire serviceable market with no untreated group to compare against.',
        options: [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ],
        required: true,
    },
    testControlAllocation: {
        question: 'Is Test/Control allocation available?',
        info: 'Select YES if you know which stores or customers received the intervention (test) and which did not (control).',
        options: [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ],
        required: true,
    },
    kpiPrePeriodData: {
        question: 'Is pre-intervention data available?',
        info: 'Select YES if KPI data from the period before the intervention is available.',
        options: [
            { label: 'Yes', value: true },
            { label: 'No', value: false },
        ],
        required: true,
    },
    interventionCount: {
        question: 'How many interventions do you want to run at once?',
        info: "Select 1 if you're measuring the impact of a single change. Select 2 or more if you're comparing multiple approaches to see which combination works best.",
        count: true,
        required: true,
        countlabel: 'intervention',
    },
}

export const MAX_SIMULTANEOUS_INTERVENTIONS = 5

const leaf = (outcome: DecisionOutcome): DecisionNode => ({ kind: 'leaf', outcome })
const typeLeaf = (type: experimentTypeKeys) => leaf({ kind: 'type', type })
const NOT_POSSIBLE = leaf({ kind: 'notPossible' })

const interventionCountNode = (single: DecisionNode): DecisionNode => ({
    kind: 'count',
    key: 'interventionCount',
    ranges: [
        { min: 1, max: 1, next: single },
        { min: 2, max: MAX_SIMULTANEOUS_INTERVENTIONS, next: typeLeaf('MTE') },
    ],
})

const fullCoverageDmlNode: DecisionNode = {
    kind: 'question',
    key: 'kpiPrePeriodData',
    yesLabel: 'Yes (with covariates)',
    yes: typeLeaf('DML'),
    no: NOT_POSSIBLE,
}

export const EXPERIMENT_DECISION_TREES: Record<ExperimentMode, DecisionNode> = {
    measure: {
        kind: 'question',
        key: 'interventionOccurred',
        fixedValue: true,
        no: NOT_POSSIBLE,
        yes: {
            kind: 'question',
            key: 'interventionOnGroup',
            yes: fullCoverageDmlNode,
            no: {
                kind: 'question',
                key: 'testControlAllocation',
                yes: {
                    kind: 'question',
                    key: 'kpiPrePeriodData',
                    yes: interventionCountNode(leaf({ kind: 'choice', types: ['RCT', 'OBS'] })),
                    no: typeLeaf('PTC'),
                },
                no: {
                    kind: 'question',
                    key: 'kpiPrePeriodData',
                    yes: leaf({ kind: 'designObservationalFirst' }),
                    no: NOT_POSSIBLE,
                },
            },
        },
    },
    design: {
        kind: 'question',
        key: 'interventionOccurred',
        yes: {
            kind: 'question',
            key: 'interventionOnGroup',
            yes: fullCoverageDmlNode,
            no: {
                kind: 'question',
                key: 'kpiPrePeriodData',
                yes: typeLeaf('OBS'),
                no: NOT_POSSIBLE,
            },
        },
        no: {
            kind: 'question',
            key: 'interventionOnGroup',
            yes: fullCoverageDmlNode,
            no: {
                kind: 'question',
                key: 'kpiPrePeriodData',
                yes: interventionCountNode(typeLeaf('RCT')),
                no: interventionCountNode(typeLeaf('PTC')),
            },
        },
    },
}
